import {
    cilAccountLogout,
    cilChevronBottom,
    cilChevronLeft,
    cilChevronRight,
    cilInfo,
    cilArrowBottom,
    cilArrowTop,
    cilSwapVertical,
    cilBrowser,
    cilBrush,
    cilCheckCircle,
    cilClone,
    cilCloudDownload,
    cilCloudUpload,
    cilCode,
    cilColorPalette,
    cilContrast,
    cilDataTransferDown,
    cilDescription,
    cilExternalLink,
    cilFactorySlash,
    cilFile,
    cilFindInPage,
    cilFolder,
    cilFullscreen,
    cilGlobeAlt,
    cilGraph,
    cilGroup,
    cilHistory,
    cilIndustry,
    cilInstitution,
    cilLan,
    cilLayers,
    cilSitemap,
    cilLink,
    cilLinkAlt,
    cilCenterFocus,
    cilLockLocked,
    cilLockUnlocked,
    cilLowVision,
    cilMap,
    cilMediaPlay,
    cilMenu,
    cilMoon,
    cilOptions,
    cilPen,
    cilPencil,
    cilPlus,
    cilReload,
    cilSave,
    cilSearch,
    cilSettings,
    cilShieldAlt,
    cilSpeedometer,
    cilSpreadsheet,
    cilSun,
    cilTrash,
    cilUser,
    cilUserPlus,
    cilViewColumn,
    cilWarning,
    cilX,
} from '@coreui/icons';

export const iconSubset = {
    cilChevronBottom,
    cilChevronLeft,
    cilChevronRight,
    cilMenu,
    cilUser,
    cilLockLocked,
    cilTrash,
    cilCloudUpload,
    cilCloudDownload,
    cilDataTransferDown,
    cilSave,
    cilSearch,
    cilLink,
    cilLinkAlt,
    cilPen,
    cilPencil,
    cilPlus,
    cilSpreadsheet,
    cilFile,
    cilViewColumn,
    cilBrowser,
    cilBrush,
    cilGraph,
    cilSettings,
    cilMap,
    cilLan,
    cilCenterFocus,
    cilLowVision,
    cilUserPlus,
    cilIndustry,
    cilGroup,
    cilHistory,
    cilLockUnlocked,
    cilMediaPlay,
    cilReload,
    cilGlobeAlt,
    cilInstitution,
    cilDescription,
    cilAccountLogout,
    cilFactorySlash,
    cilColorPalette,
    cilContrast,
    cilCode,
    cilMoon,
    cilSun,
    cilFindInPage,
    cilFolder,
    cilFullscreen,
    cilExternalLink,
    cilArrowTop,
    cilArrowBottom,
    cilSwapVertical,
    cilWarning,
    cilX,
    cilLayers,
    cilShieldAlt,
    cilSpeedometer,
    cilInfo,
    cilCheckCircle,
    cilClone,
    cilOptions,
    cilSitemap,
};

export enum IconSubset {
    cilChevronBottom = 'cilChevronBottom',
    cilChevronLeft = 'cilChevronLeft',
    cilChevronRight = 'cilChevronRight',
    cilMenu = 'cilMenu',
    cilUser = 'cilUser',
    cilLockLocked = 'cilLockLocked',
    cilCheckCircle = 'cilCheckCircle',
    cilTrash = 'cilTrash',
    cilCloudUpload = 'cilCloudUpload',
    cilCloudDownload = 'cilCloudDownload',
    cilDataTransferDown = 'cilDataTransferDown',
    cilSave = 'cilSave',
    cilLink = 'cilLink',
    cilLinkAlt = 'cilLinkAlt',
    cilPen = 'cilPen',
    cilPencil = 'cilPencil',
    cilPlus = 'cilPlus',
    cilSpreadsheet = 'cilSpreadsheet',
    cilFile = 'cilFile',
    cilViewColumn = 'cilViewColumn',
    cilBrowser = 'cilBrowser',
    cilBrush = 'cilBrush',
    cilGraph = 'cilGraph',
    cilSettings = 'cilSettings',
    cilMap = 'cilMap',
    cilLan = 'cilLan',
    cilUserPlus = 'cilUserPlus',
    cilIndustry = 'cilIndustry',
    cilGroup = 'cilGroup',
    cilLockUnlocked = 'cilLockUnlocked',
    cilReload = 'cilReload',
    cilGlobeAlt = 'cilGlobeAlt',
    cilInstitution = 'cilInstitution',
    cilDescription = 'cilDescription',
    cilAccountLogout = 'cilAccountLogout',
    cilFactorySlash = 'cilFactorySlash',
    cilColorPalette = 'cilColorPalette',
    cilCode = 'cilCode',
    cilFindInPage = 'cilFindInPage',
    cilFolder = 'cilFolder',
    cilExternalLink = 'cilExternalLink',
    cilArrowTop = 'cilArrowTop',
    cilArrowBottom = 'cilArrowBottom',
    cilSwapVertical = 'cilSwapVertical',
    cilWarning = 'cilWarning',
    cilX = 'cilX',
    cilHistory = 'cilHistory',
    cilMediaPlay = 'cilMediaPlay',
    cilFullscreen = 'cilFullscreen',
    cilSpeedometer = 'cilSpeedometer',
}
